import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { aiPlanningEntrypoint } from '@jira/spa-apps__ai-planning/src/aiPlanningEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { softwarePlannerClassicRoute } from '@jira/router-routes__software-ai-planning-routes/src/softwarePlannerClassicRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const aiPlanningClassicSoftwarePageEntrypoint = createPageEntryPoint({
	main: aiPlanningEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const softwarePlannerClassicRouteEntry: Route = createEntry(
	softwarePlannerClassicRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'software-planner-classic',
		layout: classicSoftwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			projectThemeResource,
		],

		meta: {
			reporting: {
				id: 'software-planner-classic',
				packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
				teamName: 'Dev AI - Planner',
			},
		},

		entryPoint: () =>
			fg('jira_ai_planner_tab') ? aiPlanningClassicSoftwarePageEntrypoint : notFoundPageEntrypoint,

		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
